<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title"></h4>
    </div>
    <div class="row" style="padding: 0px 15px 0px">
      <div class="col-md-12">
          <label>Die Bilder im Format .jpg, oder .png sollten maximal 600 Pixel breit und maximal 400 Pixel hoch sein.</label>
          <label>Die Bild-Datei sollte nicht grösser als 100 KB sein.</label>
      </div>
    </div>
    <div v-if="this.$store.state.betgameData" class="card-content">
      <form>

        <div v-for="(slide, index) in this.slides" class="row" style="margin-top: 25px;
        border: 1px solid lightgray; margin-left: 0px; margin-right: 0px">
          <div class="col-md-3" style="text-align: center; padding: 5px;">
            <img v-if="slide.image && slide.image.length > 0" style="max-width: 175px; max-height: 200px; border: darkgray 1px solid;" :src="buildSlidePath(slide.image, 300)">
            <!--<img v-else-if="index >= 0 && index < 3" style="max-width: 200px; max-height: 200px" :src="'https://teamtip.net/images/slides/slide_' + (index+1) + '.png'">-->
            <input :id="'imageFileInput' + slide.id" type="file" multiple :name="'uploadFieldName' + slide.id" @change="filesChange($event.target.name, $event.target.files, slide.id); fileCount = $event.target.files.length"
                   accept="image/*" class="input-file" style="display: none" hidden>
            <div style="text-align: center; margin-top: 10px; margin-bottom: 10px;">
              <button class="btn btn-info btn-fill btn-wd" @click.prevent="uploadButtonClicked(slide.id)">Bild ändern</button>
            </div>
          </div>
          <div class="col-md-9" style="padding: 5px;">
            <fg-input type="text"
                      label="Titel"
                      placeholder="Title"
                      v-model="slide.title">
            </fg-input>
            <fg-input type="text"
                      label="Text"
                      placeholder="Text"
                      v-model="slide.text">
            </fg-input>
            <fg-input type="text"
                      label="Link"
                      placeholder="Link"
                      v-model="slide.link">
            </fg-input>
            </div>
        </div>

        <div class="text-right" style="margin-top: 30px; margin-bottom: 30px;">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateBetgame">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    created () {
      if (!this.$store.state.betgameData) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame).then(() => {
        })
      }
      if (this.$store.state.betgame) {
        this.$store.dispatch('fetchBetgameSlides', this.$store.state.betgame).then(() => {
        })
      }
    },
    mounted () {
    },
    computed: {
      betgameId () {
        return '' + this.$store.state.betgameData.id
      },
      slides () {
        return this.$store.state.betgameSlides
      }
    },
    methods: {
      updateBetgame () {
        for (var i in this.slides) {
          const slide = this.slides[i]
          this.$store.dispatch('patchBetgameSlides', {
            title: slide.title,
            fk_betgame: slide.fk_betgame,
            id: slide.id,
            image: slide.image,
            text: slide.text,
            position: slide.position,
            link: slide.link
          })
            .then(() => {
            })
            .catch(function (error) {
              this.$log.debug(error)
            })
            .finally(function () {
            })
        }
      },
      save (file, slide) {
        this.$store.dispatch('uploadBetgameSlide',
          {
            file: file,
            slide: slide
          })
          .then((res) => {
            for (var i in this.$store.state.betgameSlides) {
              const slide = this.$store.state.betgameSlides[i]
              if (slide.id === parseInt(res.slideid)) {
                slide.image = res.filename
              }
            }
          })
          .catch(err => {
            this.$log.debug(err)
          })
      },
      filesChange (fieldName, fileList, slide) {
        if (!fileList.length) return
        let file = fileList[0]
        let fileSizeinMB = file.size / 1024 / 1024
        if (fileSizeinMB < 10) {
          this.save(file, slide)
        }
      },
      uploadButtonClicked (id) {
        document.getElementById('imageFileInput' + id).click()
      },
      buildSlidePath (icon, width) {
        return window.sessionStorage.getItem('bgbackend_apiUrl') + '/slides/' + width + '/' + icon
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditSlidesForm.vue